import * as types from "../actions/actionTypes";
const initialState = {
  loading: true,
  data: [],
  last_item: ""
};

const Event = (state = initialState, action) => {
  switch (action.type) {
    case types.EVENT_LIST_REQUEST:
      return { ...state, loading: true };
    case types.EVENT_LIST_SUCCESS:
      return { ...state, ...action.payLoad };
    case types.EVENT_LIST_FAILURE:
      return { ...state, ...action.payLoad };
    default:
      return state;
  }
};

export default Event;
